// composable/useBegrenzung.js
// Anfangsbegrenzung eines Zahntarifs als Stufen (Summen), z. B.
//   1. Jahr: 1.000,- € · 1.–2. Jahr: 3.000,- € · 1.–3. Jahr: 6.000,- € · ab dem 4. Jahr: unbegrenzt
// Die Stufen berechnet api.waizmannpro.de (ZahnData::getBegrenzungStufen → tarif.tarif_begrenzung_stufen).
// Fehlt das Feld (alte API), gilt die bisherige Anzeige 1.–2. / 3.–4. Jahr aus tarif_int_begrenzung_2/_4.
export function useBegrenzung() {
  const freiAb = (tarif) => Number((tarif && tarif.tarif_int_begrenzung_frei_ab) || 0);

  // Betrag im Stil "900,- €" (bereits formatierte Werte und Text wie "unbegrenzt" bleiben)
  const wertLang = (wert) => {
    const m = String(wert || "").trim().match(/^([0-9.]+)\s*(€|EUR|Euro)?$/i);
    if (!m) return String(wert || "");
    const zahl = Number(m[1].replace(/\./g, ""));
    return zahl.toLocaleString("de-DE") + ",- €";
  };

  // [{ label, wert, frei }] – wert immer im Stil "900,- €", frei = "unbegrenzt"-Stufe
  const stufen = (tarif) => {
    if (!tarif) return [];
    const roh =
      Array.isArray(tarif.tarif_begrenzung_stufen) && tarif.tarif_begrenzung_stufen.length
        ? tarif.tarif_begrenzung_stufen
        : [
            { label: "1.–2. Jahr", wert: tarif.tarif_int_begrenzung_2 || "" },
            { label: "3.–4. Jahr", wert: tarif.tarif_int_begrenzung_4 || "" },
          ];
    return roh.map((s) => ({ label: s.label, wert: wertLang(s.wert), frei: s.wert === "unbegrenzt" }));
  };

  // Unterzeile neben "Max. Leistung"/"Begrenzung"
  const untertitel = (tarif) => {
    const f = freiAb(tarif);
    if (f === 1) return "keine Anfangsbegrenzung";
    if (f > 1) return "bis zum " + (f - 1) + ". Jahr";
    return "in den ersten 4 Jahren";
  };

  // Eine Zeile für enge Tabellen (3er-Vergleich): "max. 6.000,- € bis 3. J. · ab 4. J. unbegrenzt"
  const kurz = (tarif) => {
    const f = freiAb(tarif);
    if (f === 1) return "unbegrenzt";
    if (f > 1) {
      const begrenzt = stufen(tarif).filter((s) => !s.frei);
      const letzte = begrenzt[begrenzt.length - 1];
      const ab = "ab " + f + ". J. unbegrenzt";
      return letzte ? "max. " + letzte.wert + " bis " + (f - 1) + ". J. · " + ab : ab;
    }
    return stufen(tarif)
      .map((s) => s.label.replace(" Jahr", " J.") + ": " + s.wert)
      .join(" · ");
  };

  return { stufen, untertitel, kurz, freiAb, wertLang };
}
